<template>
<v-container grid-list-lg fluid>
  <v-layout row wrap align-center justify-center fill-height>
    <v-flex xs12>
      <h2 class="display-1 mb-3 text-xs-center">Welcome to PR PO eApproval Portal</h2>
    </v-flex>
    <!-- <v-flex xs12 md4>
      <v-card class="white--text" color="secondary" to="/report/pr-report">
        <v-card-title>
          <div class="text-xs-center title">Pending PR</div>
        </v-card-title>
        <v-card-text>
          <div class="text-xs-center display-4">{{getPendingPR}}</div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 md4>
      <v-card class="white--text" color="purple" to="/report/po-report">
        <v-card-title>
          <div class="text-xs-center title">Pending PO</div>
        </v-card-title>
        <v-card-text>
          <div class="text-xs-center display-4">{{getPendingPO}}</div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 md4>
      <v-card class="white--text" color="primary" to="/approver">
        <v-card-title>
          <div class="text-xs-center title">Active Users</div>
        </v-card-title>
        <v-card-text>
          <div class="text-xs-center display-4">{{getTotalUser}}</div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">List of unauthorized/blocked devices</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-data-table :loading="getLoading" v-bind:headers="headers" v-bind:items="getUserNotNullDevices" v-bind:search="search"
            v-model="selected" item-key="id" class="elevation-0">
            <template slot="headerCell" slot-scope="props">
              <span>
                {{ props.header.text }}
              </span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-tooltip bottom v-if="props.item.is_blocked === 0">
                  <v-btn flat icon @click="setDeviceStatus(props.item.id, props.item.is_blocked)" color="red" slot="activator">
                    <v-icon>block</v-icon>
                  </v-btn>
                  <span>Deactivate</span>
                </v-tooltip>

                <v-tooltip bottom v-if="props.item.is_blocked === 1">
                  <v-btn flat icon @click="setDeviceStatus(props.item.id, props.item.is_blocked)" color="primary" slot="activator">
                    <v-icon>check_circle</v-icon>
                  </v-btn>
                  <span>Activate</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{ props.item.created_date | formatDateTime}}</td>
              <td class="text-xs-left">{{ props.item.device_name}}</td>
              <td class="text-xs-left">{{ props.item.employee_id}}</td>
              <td class="text-xs-left">{{ props.item.first_name}}</td>
              <td class="text-xs-left">{{ props.item.last_name}}</td>
              <td class="text-xs-left">{{ props.item.is_blocked === 1 ? `Inactive` : `Activate`}}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">List of current login users</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-data-table :loading="getLoading" v-bind:headers="currentLoginUserHeaders" v-bind:items="getCurrentLoginUsers" v-bind:search="search"
            v-model="selected" item-key="id" class="elevation-0">
            <template slot="headerCell" slot-scope="props">
              <span>
                {{ props.header.text }}
              </span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.employee_id}}</td>
              <td class="text-xs-left">{{ props.item.first_name}}</td>
              <td class="text-xs-left">{{ props.item.last_name}}</td>
              <td class="text-xs-left">{{ props.item.device_name}}</td>
              <td class="text-xs-left">{{ props.item.last_log_in_date | formatDateTime}}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 class="mt-3">
    </v-flex> -->
  </v-layout>
</v-container>
  
</template>


<script>
// import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Dashboard'
  // data () {
  //   return {
  //     search: '',
  //     selected: [],
  //     headers: [
  //       {
  //         text: 'Action',
  //         align: 'left',
  //         value: 'action',
  //         sortable: false
  //       },
  //       {
  //         text: 'Date',
  //         align: 'left',
  //         value: 'created_date'
  //       },
  //       {
  //         text: 'Device Name',
  //         align: 'left',
  //         value: 'device_name'
  //       },
  //       {
  //         text: 'Employee ID',
  //         align: 'left',
  //         value: 'employee_id'
  //       },
  //       {
  //         text: 'First name',
  //         align: 'left',
  //         value: 'first_name'
  //       },
  //       {
  //         text: 'Last name',
  //         align: 'left',
  //         value: 'last_name'
  //       },
  //       {
  //         text: 'Status',
  //         align: 'left',
  //         value: 'status'
  //       }
  //     ],
  //     currentLoginUserHeaders: [
  //       {
  //         text: 'Employee ID',
  //         align: 'left',
  //         value: 'employee_id'
  //       },
  //       {
  //         text: 'First name',
  //         align: 'left',
  //         value: 'first_name'
  //       },
  //       {
  //         text: 'Last name',
  //         align: 'left',
  //         value: 'last_name'
  //       },
  //       {
  //         text: 'Device Name',
  //         align: 'left',
  //         value: 'device_name'
  //       },
  //       {
  //         text: 'Login since',
  //         align: 'left',
  //         value: 'last_log_in_date'
  //       }
  //     ]
  //   }
  // },
  // computed: {
  //   ...mapGetters([
  //     'getUserNotNullDevices',
  //     'getPendingPR',
  //     'getPendingPO',
  //     'getTotalUser',
  //     'getLoading',
  //     'getResponse',
  //     'getCurrentLoginUsers'
  //   ])
  // },
  // methods: {
  //   ...mapActions([
  //     'fetchBlockedDevices',
  //     'blockUserDevice',
  //     'fetchPendingPR',
  //     'fetchPendingPO',
  //     'fetchTotalUser',
  //     'fetchCurrentLoginUsers'
  //   ]),

  //   setDeviceStatus (_id, _status) {
  //     let status = _status === 1 ? 0 : 1
  //     this.blockUserDevice({ id: _id, is_blocked: status }).then(() => {
  //       // do nothing
  //     })
  //   }
  // },
  // mounted: function () {
  //   this.fetchBlockedDevices().then(() => {
  //     // do nothing
  //   })
  //   this.fetchPendingPR().then(() => {
  //     // do nothing
  //   })
  //   this.fetchPendingPO().then(() => {
  //     // do nothing
  //   })
  //   this.fetchTotalUser().then(() => {
  //     // do nothing
  //   })
  //   this.fetchCurrentLoginUsers().then(() => {
  //     // do nothing
  //   })
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue